import { useBoolean, useId } from '@uifabric/react-hooks';
import { useEffect, useState } from 'react';
import { idpService } from 'services/api/identity-provider.service';

export interface ICommunicationSettingsState {
    currentDeviceSettings: {
        cameraDisabled: boolean;
        microphoneDisabled: boolean;
    };
    toggleDeviceSettings: (toggle: string) => Promise<void>;
    hideErrorDialog: boolean;
    toggleHideErrorDialog: () => void;
    colorButtonId: string;
    deviceSettings: any;
}

// Read by RoomView.view.tsx to check whether the camera/mic should default to off on room entry —
// a module-level object (rather than plain hook state) so that consumer can read the latest saved
// value without needing to share the same hook instance.
export const deviceSettings: any = {};

export const useCommunicationSettingsState: () => ICommunicationSettingsState = () => {
    const [hideErrorDialog, { toggle: toggleHideErrorDialog }] = useBoolean(true);
    const colorButtonId = useId('callout-button');
    const [currentDeviceSettings, setCurrentDeviceSettings] = useState<{ cameraDisabled: boolean; microphoneDisabled: boolean }>({
        cameraDisabled: false,
        microphoneDisabled: false
    });

    useEffect(() => {
        const getUserData = async () => {
            try {
                const response = await idpService.getUser();
                deviceSettings.cameraDisabled = response.device_settings.camera_disabled;
                deviceSettings.microphoneDisabled = response.device_settings.mic_disabled;
                setCurrentDeviceSettings({
                    cameraDisabled: response.device_settings.camera_disabled,
                    microphoneDisabled: response.device_settings.mic_disabled
                });
            } catch (error) {
                console.log(error);
            }
        };

        getUserData();
    }, []);

    const toggleDeviceSettings = async (toggle: string) => {
        const currentCameraSetup = toggle == 'camera' ? !currentDeviceSettings.cameraDisabled : currentDeviceSettings.cameraDisabled;
        const currentMicSetup = toggle == 'mic' ? !currentDeviceSettings.microphoneDisabled : currentDeviceSettings.microphoneDisabled;
        setCurrentDeviceSettings({ cameraDisabled: currentCameraSetup, microphoneDisabled: currentMicSetup });

        try {
            const updateResponse = await idpService.updateUser(undefined, undefined, undefined, undefined, currentCameraSetup, currentMicSetup);
            deviceSettings.cameraDisabled = updateResponse.device_settings.camera_disabled;
            deviceSettings.microphoneDisabled = updateResponse.device_settings.mic_disabled;
        } catch {
            toggleHideErrorDialog();
        }
    };

    return {
        currentDeviceSettings,
        toggleDeviceSettings,
        hideErrorDialog,
        toggleHideErrorDialog,
        colorButtonId,
        deviceSettings
    };
};
